import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { screens } from "../lessons";

export default function Lesson() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [revealed, setRevealed] = useState(false);
  const lessonId = parseInt(id);
  const lesson = screens[lessonId];

  const handleFinish = () => {
    let currentXp = Number(localStorage.getItem('sur_xp')) || 0;
    let comp = JSON.parse(localStorage.getItem('sur_comp')) || [];
    if (!comp.includes(lessonId)) {
      const bonus = lesson.type === 'socratic' ? 30 : 20;
      localStorage.setItem('sur_xp', (currentXp + bonus).toString());
      localStorage.setItem('sur_comp', JSON.stringify([...comp, lessonId]));
    }
    navigate("/dashboard");
  };

  return (
    <div className="viewport">
      <div className="card">
        <button onClick={() => navigate("/dashboard")}>← Back</button>
        <h2>{lesson.title}</h2>
        {lesson.type === 'socratic' ? (
          <div className="socratic-ui">
            <p className="hook"><i>"{lesson.hook}"</i></p>
            <p>{lesson.question}</p>
            {!revealed ? (
              <button onClick={() => setRevealed(true)} className="finish-btn">Make Prediction</button>
            ) : (
              <div className="reveal-zone">
                <p><strong>The Reveal:</strong> {lesson.reveal}</p>
                <p><strong>Action:</strong> {lesson.action}</p>
                <button onClick={handleFinish} className="finish-btn">Complete (+30 XP)</button>
              </div>
            )}
          </div>
        ) : (
          <div>
            {lesson.body?.map((line, i) => <p key={i}>{line}</p>)}
            <button onClick={handleFinish} className="finish-btn">Complete (+20 XP)</button>
          </div>
        )}
      </div>
    </div>
  );
}
